<div class="overlay"></div>

<div class="box">

	<div class="content">

		<img alt="LorenzMesse Logo" class="logo" src="https://www.lorenz-messe.de/bilder/Logo/Logo-LorenzMesse.png">

		<hr>

		<h1>{{ titleDe }}</h1>
		<p>Die Anfrage konnte nicht abgeschlossen werden. Schließe diese Meldung und versuche es bitte noch einmal.</p>

		<h1>{{ titleEn }}</h1>
		<p>The request could not be completed. Close this message and please try again.</p>

		<div class="diagnostic">
			<p>Falls das Problem erneut auftritt, teile uns bitte diese Angaben mit:</p>
			<p class="diagnostic-primary">
				<span>Fehlercode: <strong>{{ diagnostic.errorCode }}</strong></span>
				<span>Request-ID: <strong>{{ diagnostic.requestId }}</strong></span>
				<span>Client-Referenz: <strong>{{ diagnostic.clientReference }}</strong></span>
				<span>Uhrzeit: <strong>{{ diagnostic.displayTime }}</strong></span>
			</p>

			<details>
				<summary>Technische Details</summary>
				<dl>
					<dt>Technischer Status</dt><dd>{{ diagnostic.technicalStatus }}</dd>
					<dt>Diagnose</dt><dd>{{ diagnostic.diagnosis }}</dd>
					<dt>API-Fehlercode</dt><dd>{{ diagnostic.apiErrorCode }}</dd>
					<dt>Request-ID</dt><dd>{{ diagnostic.requestId }}</dd>
					<dt>Client-Referenz</dt><dd>{{ diagnostic.clientReference }}</dd>
					<dt>Browser-Netzwerkstatus</dt><dd>{{ diagnostic.connection }}</dd>
					<dt>Netzwerktyp</dt><dd>{{ diagnostic.networkType }}</dd>
					<dt>Frontend</dt><dd>{{ diagnostic.frontend }}</dd>
					<dt>Build</dt><dd>{{ diagnostic.build }}</dd>
					<dt>Server</dt><dd>{{ diagnostic.server }}</dd>
					<dt>Anfrage</dt><dd>{{ diagnostic.request }}</dd>
					<dt>Browser/Gerät</dt><dd>{{ diagnostic.browser }}</dd>
					<dt>Retry-After</dt><dd>{{ diagnostic.retryAfter }}</dd>
				</dl>
			</details>

			<div class="actions">
				<button type="button" class="primary" (click)="dismiss()">Meldung schließen</button>
				<button type="button" (click)="copyDiagnosticDetails()">Details kopieren</button>
			</div>

			@if (copyState) {
				<p class="copy-state" aria-live="polite">{{ copyState }}</p>
			}
		</div>

		<hr>

		<a href="https://www.lorenz-messe.de/">LorenzMesse Homepage</a>

	</div>

</div>
